class ProductAnimation extends HTMLElement {
  constructor() {
    super();
    this.lottieInstance = null;
  }

  connectedCallback() {
    const animationUrl = this.getAttribute('animation-url');
    if (animationUrl) {
      if (typeof lottie !== 'undefined') {
        this.loadAnimation(animationUrl);
      } else {
        console.error('Lottie is not defined. Make sure the library is loaded.');
      }
    }
  }

  loadAnimation(url) {
    const container = document.createElement('div');
    container.style.width = '100%';
    this.appendChild(container);

    this.lottieInstance = lottie.loadAnimation({
      container,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: url,
    });

    this.addHoverEvents();
  }

  addHoverEvents() {
    this.addEventListener('mouseenter', () => {
      if (this.lottieInstance) {
        this.lottieInstance.playSegments([0, 30], true)
      }
    });

    this.addEventListener('mouseleave', () => {
      if (this.lottieInstance) {
        this.lottieInstance.playSegments([31, 100], true);
      }
    });
  }
}

customElements.define('product-animation', ProductAnimation);
